import { HubConnectionBuilder } from '@aspnet/signalr';
import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import FormControlLabel from '@mui/material/FormControlLabel';
import IconButton from '@mui/material/IconButton';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import TextField from '@mui/material/TextField';
import AddIcon from '@mui/icons-material/AddCircleOutline';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import SearchIcon from '@mui/icons-material/Search';
import React, { Component } from 'react';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import mainStore from '../../../MainStore';
import authStore from '../../Auth/AuthStore';
import InvoiceBoardCard from './InvoiceBoardCard';
import InvoiceDialog from './InvoiceDialog';
import { ExpensesByMonthReport } from './Reports/ExpensesByMonthReport';
import { ProfitByMonthReport } from './Reports/ProfitByMonthReport';
import SaleBoardCard from './SaleBoardCard';
import SaleDialog from './SaleDialog';
import './sales.css';
import SaleStore from './SaleStore';
import SaleGoalBar from './SaleGoalBar';

/*
 * The SaleBoard React component
 */
export default class Sales extends Component {
	render(){    
		return(
            <div>
                <SaleBoard />
            </div>
		);
	}
}

/*
 * The SaleBoard Board React component
 */
class SaleBoard extends Component {
	constructor(props) {
		super(props);
		this.state = ({
            sales: [],
            invoices: [],
            draggedOverCol: 0,
            isSaleDialogOpen: false,
            dragSrcPosition: 0,
            sale: {
            },
            selectedTab: 0,
            searchStr: '',
            searchType: 0,
            isOnlyMy: localStorage.getItem('filter_isOnlyMySale') === 'true',
            isOnlyMyInvoice: localStorage.getItem('filter_isOnlyMyInvoice') === 'true',
            isOnlyMyProjects: false,
            filterProjectId: '',
            info: {
                paymentAmount: 0
            },
            paymentsInCurrentMonth: 0,
            paymentsInNextMonth: 0
        });

		this.handleOnDragEnter = this.handleOnDragEnter.bind(this);
		this.handleOnDragEnd = this.handleOnDragEnd.bind(this);
        this.handleCardOpen = this.handleCardOpen.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.handleCardAdd = this.handleCardAdd.bind(this);
        this.handleSave = this.handleSave.bind(this);
        this.handleRowDataChange = this.handleRowDataChange.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleTabChange = this.handleTabChange.bind(this);
        this.handleDragSrcPositionChange = this.handleDragSrcPositionChange.bind(this);
        this.onTimeChange = this.onTimeChange.bind(this);
        this.startSearch = this.startSearch.bind(this);
        this.handleQuickFilterMyChange = this.handleQuickFilterMyChange.bind(this);
        this.handleQuickFilterMyInvoiceChange = this.handleQuickFilterMyInvoiceChange.bind(this);
        this.handleQuickFilterMyProjectChange = this.handleQuickFilterMyProjectChange.bind(this);
        this.handleQuickFilterProjectChange = this.handleQuickFilterProjectChange.bind(this);
        this.handleCtrlCardClick = this.handleCtrlCardClick.bind(this);
        this.handleSaleUpdate = this.handleSaleUpdate.bind(this);
        this.handleSaleFlagUpdate = this.handleSaleFlagUpdate.bind(this);
        this.handleInvoiceUpdate = this.handleInvoiceUpdate.bind(this);
        this.updateLeadFromCRM = this.updateLeadFromCRM.bind(this);
        this.loadSales = this.loadSales.bind(this);
        this.loadInvoices = this.loadInvoices.bind(this);
        this.loadAdditionalInfo = this.loadAdditionalInfo.bind(this);
        this.handleExpandedChange = this.handleExpandedChange.bind(this);
        this.loadAll = this.loadAll.bind(this);

		this.columns = [
            { name: 'Backlog', id: 'b78502d9-f71d-4c73-abff-3c0fbe6a5d30' },
            { name: 'Зафиксировать цели', id: 'e13a129f-857e-4ae2-8e27-28e48f739464' },
            { name: 'Подготовить бюджет', id: 'b434484c-0747-4fb7-8fcb-07096c20de80' },
            { name: 'Согласовать бюджет', id: 'b434484c-0747-4fb7-8fcb-07096c20de81' },
            { name: 'Провести ППО', id: '29c7f1d7-6c7d-431d-9815-cc4e7e572b09'},
            { name: 'Подготовить КП', id: '24313bff-e9da-4a66-a92f-095034534389' },
            //{ name: 'Ожидание защиты КП', id: 'ee75bb55-51a8-4f43-8be0-46aba85b302f' },
            { name: 'Согласовать КП с клиентом', id: '0ca5716b-0789-4642-9a6b-be466847198b' },
            { name: 'Согласовать договор с клиентом', id: '36fd15d2-06b4-466e-a94d-ed3b2ccca42f' },
            { name: 'Подписать договор', id: '528c3942-0448-42e3-9337-a4464b842e9a' },
            { name: 'Получить оплату', id: 'e5a35847-b697-4bb8-97ae-936cab295493', isInvoice: true, showCurrentMonthPayment: true },
            { name: 'Следующий месяц', id: '832e2c34-4a87-4e84-bf2a-3127f8e30880', isInvoice: true, showNextMonthPayment: true },
            { name: 'Оплаты будущего', id: '5721295c-bad4-433c-b778-8aee2993374d', isInvoice: true },
            //{ name: 'Подписать акт', id: 'a906cd76-4dec-4537-9270-a02069e6a0b3', isInvoice: true },
            //{ name: 'Доплата', id: '066accef-2186-43a4-b675-07fdb0732c8e' },
        ];

        var scope = this;

        const hubConnection = new HubConnectionBuilder()
            .withUrl("/hub")
            .build();

        hubConnection.on('saleUpdated', (sale) => {
            var sales = scope.state.sales;

            var index = sales.findIndex(w => w.id === sale.id);
            if (index === -1) {
                sales.push(sale);
            }
            else {
                sales[index] = sale;
            }

            sales = sales.sort((a, b) => b.position - a.position);
            scope.setState({ sales: sales });
        });

        hubConnection.on('invoiceUpdated', (invoice) => {
            var invoices = scope.state.invoices;

            var index = invoices.findIndex(w => w.id === invoice.id);
            if (index === -1) {
                invoices.push(invoice);
            }
            else {
                invoices[index] = invoice;
            }

            invoices = invoices.sort((a, b) => new Date(a.date) - new Date(b.date));
            scope.setState({ invoices: invoices });
        });

        hubConnection.on('saleSchedulleUpdated', (sale) => {
            var sales = scope.state.sales.slice(0);
            var index = sales.findIndex(w => w.id === sale.workId);
            if (index > -1) {
                sales[index].factTotal = sale.total;
                scope.setState({sales: sales});
            }

            /*var works = WorkStore.getWorks.slice(0);

            var index = works.findIndex(w => w.id === work.workId);

            if (index > -1) {
                works[index].factTotal = work.total;
                WorkStore.setWorks(works);
            }*/
        });

        hubConnection.onclose((error) => { console.log('socket error'); console.log(error); hubConnection.start(); });

        hubConnection.start();
	}

    componentDidMount() {
        var scope = this;
        if (!authStore.isAuth) {
            authStore.openLogin(() => { scope.loadAll(); });
            return;
        }
        else this.loadAll();
    }

    loadAll() {
        this.loadSales();
        this.loadInvoices();
        this.loadAdditionalInfo();
        var token = localStorage.getItem("token");


        var url = new URL(document.location.href);
        var saleNumber = url.searchParams.get("sale");
        var saleId = url.searchParams.get("saleId");
        if (saleNumber) {
            mainStore.setMaskVisible();
            fetch('api/Sale/GetByNumber?number=' + encodeURIComponent(saleNumber), {
                method: 'GET',
                headers: {
                    'Authorization': 'Bearer ' + token
                },
                body: null,
            }).then(function (res) {
                if (res.status === 401) {
                    authStore.openLogin();
                    mainStore.setMaskUnvisible();
                }
                else {
                    res.json().then((result) => {
                        mainStore.setMaskUnvisible();
                        SaleStore.openSaleDialog(result);
                    }).catch((err) => console.log(err));
                }
            });
        }
        else if (saleId) {
            mainStore.setMaskVisible();
            fetch('api/Sale/GetByCrmId?id=' + encodeURIComponent(saleId), {
                method: 'GET',
                headers: {
                    'Authorization': 'Bearer ' + token
                },
                body: null,
            }).then(function (res) {
                if (res.status === 401) {
                    authStore.openLogin();
                    mainStore.setMaskUnvisible();
                }
                else {
                    res.json().then((result) => {
                        mainStore.setMaskUnvisible();
                        SaleStore.openSaleDialog(result);
                    }).catch((err) => console.log(err));
                }
            });
        }
    }

    loadInvoices() {
        var scope = this;
        var token = localStorage.getItem("token");
        fetch('api/Invoice?isOnlyMy=' + this.state.isOnlyMyInvoice, {
            method: 'GET',
            headers: {
                'Authorization': 'Bearer ' + token
            },
            body: null,
        }).then(function (res) {
            if (res.status === 401) {
                authStore.openLogin();
                mainStore.setMaskUnvisible();
            }
            else {
                res.json().then((result) => {
                    scope.setState({ invoices: result.invoices, paymentsInCurrentMonth: result.paymentsInCurrentMonth, paymentsInNextMonth: result.paymentsInNextMonth });
                }).catch((err) => console.log(err));
            }
        });
    }

    loadSales() {
        mainStore.setMaskVisible();
        var scope = this;
        var token = localStorage.getItem("token");
        fetch('api/Sale', {
            method: 'GET',
            headers: {
                'Authorization': 'Bearer ' + token
            },
            body: null,
        }).then(function (res) {
            if (res.status === 401) {
                authStore.openLogin();
                mainStore.setMaskUnvisible();
            }
            else {
                res.json().then((result) => {
                    mainStore.setMaskUnvisible();
                    scope.setState({ sales: result });
                }).catch((err) => console.log(err));
            }
        });
    }

    loadAdditionalInfo() {
        /*mainStore.setMaskVisible();
        var scope = this;
        var token = localStorage.getItem("token");
        fetch('api/Sale/AdditionalInfo', {
            method: 'GET',
            headers: {
                'Authorization': 'Bearer ' + token
            },
            body: null,
        }).then(function (res) {
            if (res.status === 401) {
                authStore.openLogin();
                mainStore.setMaskUnvisible();
            }
            else {
                res.json().then((result) => {
                    mainStore.setMaskUnvisible();
                    scope.setState({ info: result });
                }).catch((err) => console.log(err));
            }
        });*/
    }

    updateLeadFromCRM() {
        mainStore.setMaskVisible();
        var token = localStorage.getItem("token");
        var scope = this;
        fetch('api/Sale/UpdateLeadFromCRM', {
            method: 'GET',
            headers: {
                'Authorization': 'Bearer ' + token
            },
            body: null,
        }).then(function (res) {
            if (res.status === 401) {
                authStore.openLogin();
                mainStore.setMaskUnvisible();
            }
            else {
                res.json().then((result) => {
                    mainStore.setMaskUnvisible();
                    scope.loadSales();
                }).catch((err) => console.log(err));
            }
        });
    }

    handleSaleUpdate(result, isDelete) {
        var sales = this.state.sales.slice(0);

        if (isDelete) {
            var index = sales.findIndex(w => w.id === result.id);
            if (index > -1)
                sales.splice(index, 1);
        }
        else {
            if (!SaleStore.getSale.id) {
                sales.push(result);
            }
            else {
                var index = sales.findIndex(w => w.id === result.id);

                sales[index] = result;
            }
        }
        this.setState({ sales: sales, isSaleDialogOpen: false });
    }

    handleInvoiceUpdate(result, isDelete) {
        var invoices = this.state.invoices.slice(0);

        if (isDelete) {
            var index = invoices.findIndex(w => w.id === result.id);
            if(index > -1)
            invoices.splice(index, 1);
        }
        else {
            if (!SaleStore.getInvoice.id) {
                invoices.push(result);
            }
            else {
                var index = invoices.findIndex(w => w.id === result.id);
                if (index > -1)
                invoices[index] = result;
            }
        }

        this.setState({ invoices: invoices, isSaleDialogOpen: false });
    }

    handleSaleFlagUpdate(result) {
        var sales = this.state.sales.slice(0);
        var index = sales.findIndex(w => w.id === result.id);
        if (index < 0) {
            var invoices = this.state.invoices.slice(0);
            index = invoices.findIndex(w => w.id === result.id);
            invoices[index] = result;
            this.setState({ invoices: invoices, isSaleDialogOpen: false });
        }
        else {
            sales[index] = result;
            this.setState({ sales: sales, isSaleDialogOpen: false });
        }
    }

    startSearch(obj) {
        var scope = this;
        var token = localStorage.getItem("token");
        mainStore.setMaskVisible();
        fetch('api/Sale/GlobalSearch?isOnlyMy=' + this.state.isOnlyMy + '&projectId=' + this.state.filterProjectId + '&searchType=' + this.state.searchType + '&searchStr=' + this.state.searchStr + '&isMyProjects=' + this.state.isOnlyMyProjects, {
            method: 'GET',
            headers: {
                'Authorization': 'Bearer ' + token
            },
            body: null,
        }).then(function (res) {
            if (res.status === 401) {
                authStore.openLogin();
                mainStore.setMaskUnvisible();
            }
            else {
                res.json().then((result) => {
                    mainStore.setMaskUnvisible();
                    scope.setState({ sales: result });
                }).catch((err) => console.log(err));
            }
        });
    }

    handleQuickFilterMyChange(evt) {
        var isOnlyMy = evt.target.checked;
        localStorage.setItem('filter_isOnlyMySale', isOnlyMy);
        this.setState({ isOnlyMy: isOnlyMy }, () => this.startSearch(null));
    }

    handleQuickFilterMyInvoiceChange(evt) {
        var isOnlyMyInvoice = evt.target.checked;
        localStorage.setItem('filter_isOnlyMyInvoice', isOnlyMyInvoice);
        this.setState({ isOnlyMyInvoice: isOnlyMyInvoice }, () => this.loadInvoices());
    }

    handleQuickFilterMyProjectChange(evt) {
        var isOnlyMyProjects = evt.target.checked;
        this.setState({ isOnlyMyProjects: isOnlyMyProjects }, () => this.startSearch(null));
    }

    handleSave() {
        var scope = this;
        mainStore.setMaskVisible();
        var token = localStorage.getItem("token");
        fetch('api/Sale/Add', {
            method: 'POST',
            body: JSON.stringify(this.state.sale),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token
            }
        }).then(function (res) {
            if (res.status === 401) {
                authStore.openLogin();
                mainStore.setMaskUnvisible();
                scope.startSearch();
            }
            else {
                res.json().then((result) => {
                    var sales = scope.state.sales;

                    if (!scope.state.sale.id) {
                        sales.push(result);
                    }
                    else {
                        var index = sales.findIndex(w => w.id === result.id);

                        sales[index] = result;
                    }
                    mainStore.setMaskUnvisible();
                    scope.setState({ sales: sales, isSaleDialogOpen: false });
                }).catch((err) => console.log(err));
            }
        });
    }

	//this is called when a SaleBoard card is dragged over a column (called by column)
	handleOnDragEnter(e, stageValue) {
		this.setState({ draggedOverCol: stageValue });
    }

    handleDragSrcPositionChange(position) {
        this.setState({ dragSrcPosition: position });
    }

    onTimeChange(total, id) {
        var saleIndex = this.state.sales.findIndex(w => w.id === id);
        var sale = this.state.sales[saleIndex];
        sale.factTotal = total;

        this.setState({ sales: this.state.sales});
    }

	//this is called when a SaleBoard card dropped over a column (called by card)
    handleOnDragEnd(e) {
        console.log(e);
        const { destination, source, draggableId } = e;

        if (!destination) {
            return
        }

        if (
            destination.droppableId === source.droppableId &&
            destination.index === source.index
        ) {
            return
        }

        mainStore.setMaskVisible();
        var sales = this.state.sales;
        var sale = sales[sales.findIndex(s => s.id === e.draggableId)];
        var newStatusId = destination.droppableId;
        var dragSrcPosition = 0;
        var scope = this;
        var token = localStorage.getItem("token");
        if (sale) {
            if (sale.statusId === 'b78502d9-f71d-4c73-abff-3c0fbe6a5d30' && sale.statusId !== newStatusId) {
                var isContinue = window.confirm("Данное действие создаст продажу из лида. Продолжить?");

                if (!isContinue) {
                    mainStore.setMaskUnvisible();
                    return;
                }
            }
            var columnSales = sales.filter(w => w.statusId === newStatusId).sort((a, b) => b.position - a.position);
            if (columnSales.length !== 0) {
                dragSrcPosition = columnSales[e.destination.index >= columnSales.length ? columnSales.length - 1 : e.destination.index].position;
            }

            var selectedSales = sales.filter(w => w.isSelected).sort((a, b) => b.position - a.position);
            if (selectedSales.length === 0) selectedSales = [sale];

            if (sale.position < dragSrcPosition) dragSrcPosition = dragSrcPosition + 1;

            if (sale.position !== dragSrcPosition) {
                sales.forEach(w => {
                    if (w.position >= dragSrcPosition && w.id !== sale.id) {
                        w.position = w.position + selectedSales.length;
                    }
                })
            }
            else {
                dragSrcPosition = dragSrcPosition - 1;
                sales.forEach(w => {
                    if (w.position >= dragSrcPosition && w.id !== sale.id) {
                        w.position = w.position + selectedSales.length;
                    }
                })
            }

            for (var i = 0; i < selectedSales.length; i++) {
                selectedSales[i].statusId = newStatusId;
                selectedSales[i].position = dragSrcPosition + (selectedSales.length - 1 - i);

                scope.setState({ sales: scope.state.sales.slice(0), isSaleDialogOpen: false });

                fetch('api/Sale/Add', {
                    method: 'POST',
                    body: JSON.stringify(selectedSales[i]),
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + token
                    }
                }).then(function (res) {
                    if (res.status === 401) {
                        authStore.openLogin();
                        mainStore.setMaskUnvisible();
                    }
                    else {
                        res.json().then((result) => {
                            var sales = scope.state.sales;

                            var index = sales.findIndex(w => w.id === result.id);
                            sales[index] = result;

                            sales = sales.sort((a, b) => b.position - a.position);

                            mainStore.setMaskUnvisible();
                            scope.setState({ sales: sales, isSaleDialogOpen: false });
                        }).catch((err) => console.log(err));
                    }
                });
            }
        }
        else {
            var invoices = this.state.invoices;
            var invoice = invoices[invoices.findIndex(s => s.id === e.draggableId)];
            if (invoice) {
                var columnInvoices = invoices.filter(w => w.statusId === newStatusId).sort((a, b) => b.position - a.position);
                
                if (columnInvoices.length !== 0) {
                    dragSrcPosition = columnInvoices[e.destination.index >= columnInvoices.length ? columnInvoices.length - 1 : e.destination.index].position + 1;
                }

                var selectedInvoices = invoices.filter(w => w.isSelected).sort((a, b) => b.position - a.position);
                if (selectedInvoices.length === 0) selectedInvoices = [invoice];

                if (invoice.position !== dragSrcPosition) {
                    selectedInvoices.forEach(w => {
                        if (w.position >= dragSrcPosition && w.id !== invoice.id) {
                            w.position = w.position + selectedInvoices.length;
                        }
                    })
                }
                else {
                    dragSrcPosition = dragSrcPosition - 1;
                    invoices.forEach(w => {
                        if (w.position >= dragSrcPosition && w.id !== invoice.id) {
                            w.position = w.position + selectedInvoices.length;
                        }
                    })
                }

                
                for (var i = 0; i < selectedInvoices.length; i++) {
                    selectedInvoices[i].statusId = newStatusId;
                    selectedInvoices[i].position = dragSrcPosition + (selectedInvoices.length - 1 - i);

                    scope.setState({ invoices: scope.state.invoices.slice(0) });

                    fetch('api/Invoice', {
                        method: 'POST',
                        body: JSON.stringify(selectedInvoices[i]),
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': 'Bearer ' + token
                        }
                    }).then(function (res) {
                        if (res.status === 401) {
                            authStore.openLogin();
                            mainStore.setMaskUnvisible();
                        }
                        else {
                            res.json().then((result) => {
                                var invoices = scope.state.invoices;

                                var index = invoices.findIndex(w => w.id === result.id);
                                invoices[index] = result;

                                invoices = invoices.sort((a, b) => b.position - a.position);

                                mainStore.setMaskUnvisible();
                                scope.setState({ invoices: invoices });
                            }).catch((err) => console.log(err));
                        }
                    });
                }
            }
        }
    }

    handleCardOpen(sale) {
        SaleStore.openSaleDialog(sale);
    }

    handleCardAdd() {
        SaleStore.openSaleDialog({ caption: this.state.searchStr });
    }

    loadProjects() {
        var scope = this;
        mainStore.setMaskVisible();
        var token = localStorage.getItem("token");
        fetch('api/Project', {
            method: 'GET',
            headers: {
                'Authorization': 'Bearer ' + token
            },
            body: null,
        }).then(function (res) {
            if (res.status === 401) {
                authStore.openLogin();
                mainStore.setMaskUnvisible();
            }
            else {
                res.json().then((result) => {
                    mainStore.setMaskUnvisible();
                    scope.setState({ sales: result.projects });
                }).catch((err) => console.log(err));
            }
        });
    }

    handleClose() {
        this.setState({ isSaleDialogOpen: false });
    }

    handleTabChange(event, newValue) {
        this.setState({ "selectedTab": newValue });
    }

    handleChange = name => evt => {
        this.setState({ [name]: evt.target.value });
    }

    handleRowDataChange = name => evt => {
        var sale = this.state.sale;
        sale[name] = evt.target.value;
        this.setState({ sale: sale });
    }

    handleRowCheckedChange = name => evt => {
        var sale = this.state.sale;
        sale[name] = evt.target.checked;
        this.setState({ sale: sale });
    }

    handleQuickFilterProjectChange(project) {
        this.setState({ filterProjectId: project.id, filterProjectName: project.name }, () => { this.startSearch() });
        ;
    }

    handleCtrlCardClick(saleId) {
        var saleIndex = this.state.sales.findIndex(w => w.id === saleId);
        var sales = this.state.sales;

        if (saleIndex > -1) {
            sales[saleIndex].isSelected = !sales[saleIndex].isSelected;
            this.setState({ sales: sales});
        }
    }

    handleExpandedChange = value => () => {
        this.setState({ expanded: value });
    }

	render() {
		return (
            <div className="SaleBoard-columns-wrapper">
                <Accordion className="sale-filter-expand" expanded={this.state.expanded}>
                    <AccordionSummary
                        aria-controls="panel1bh-content"
                        id="panel1bh-header"
                    >
                        {!this.state.expanded && <IconButton onClick={this.handleExpandedChange(true)} size="large">
                            <ExpandMoreIcon />
                        </IconButton>}
                        {this.state.expanded && <IconButton onClick={this.handleExpandedChange(false)} size="large">
                            <ExpandLessIcon />
                        </IconButton>}
                        <div className="quick-filter-panel quick-filter-panel-sales clearfix" onClick={event => event.stopPropagation()}>
                            <div className="quick-filter-search-block">
                                    <div className="search-block clearfix">
                                    <IconButton onClick={this.handleCardAdd} size="large">
                                        <AddIcon/>
                                    </IconButton>
                                    <div className="left-40">
                                        <TextField required
                                            id="standard-required"
                                            label="Поиск"
                                            fullWidth
                                            variant="standard"
                                            margin="none"
                                            value={this.state.searchStr}
                                            autoComplete="off"
                                            onKeyPress={(event) => (event.key === 'Enter') && this.startSearch()}
                                            onChange={this.handleChange('searchStr')}
                                        />
                                    </div>
                                    <div className="search-type-button">
                                        <Select
                                            className="search-type-select"
                                            value={this.state.searchType}
                                            variant="standard"
                                            onChange={this.handleChange('searchType')}
                                        >
                                            <MenuItem value="0">Заголовок</MenuItem>
                                            <MenuItem value="1">Заголовок+Описание</MenuItem>
                                            <MenuItem value="2">Везде</MenuItem>
                                        </Select>
                                    </div>
                                    <div className="search-sale-button-wrapper">
                                        <IconButton onClick={this.startSearch} size="large">
                                            <SearchIcon />
                                        </IconButton>
                                    </div>
                                </div>
                            </div>
                            <div className="quick-filter-item">
                                <FormControlLabel
                                    control={
                                        <Checkbox checked={this.state.isOnlyMy} onChange={this.handleQuickFilterMyChange} value="true" />
                                    }
                                    label="Мои продажи"
                                />
                            </div>
                            <div className="quick-filter-item">
                                <FormControlLabel
                                    control={
                                        <Checkbox checked={this.state.isOnlyMyInvoice} onChange={this.handleQuickFilterMyInvoiceChange} value="true" />
                                    }
                                    label="Мои счета"
                                />
                            </div>
                            <div className="quick-filter-button">
                                <Button variant="outlined" color="secondary" onClick={this.updateLeadFromCRM}>Обновить лиды</Button>
                            </div>
                        </div>
                    </AccordionSummary>
                    <AccordionDetails>
                        {this.state.expanded && <div className="sale-reports">
                            <div className="sale-report-item">
                                <ProfitByMonthReport />
                            </div>
                            <div className="sale-report-item">
                                <ExpensesByMonthReport />
                            </div>
                        </div>}
                    </AccordionDetails>
                </Accordion>
                <SaleGoalBar />
                <div className="sales">
                    <DragDropContext onDragEnd={this.handleOnDragEnd}>
                        <div className="sale-board-column-headers clearfix">
                            {this.columns.map((column) => {
                                var length = 0;
                                var sum = 0;
                                var paymentAmount = 0;
                                if (column.isInvoice && this.state.invoices) {
                                    var invoices = this.state.invoices.filter((w) => { return w.statusId === column.id; });
                                    if (invoices && invoices.length > 0) {
                                        length = invoices.length;
                                        sum = invoices.reduce((a, b) => { return a + b.profit; }, 0);
                                        paymentAmount = invoices.reduce((a, b) => { return a + b.paymentAmount; }, 0);
                                    }
                                }
                                else if (this.state.sales){
                                    var sales = this.state.sales.filter((w) => { return w.statusId === column.id; });
                                    if (sales && sales.length > 0) {
                                        length = sales.length;
                                        sum = sales.reduce((a, b) => { return a + b.profit; }, 0);
                                    }
                                }
                                return (
                                    <div className="sale-board-column-title">{column.name} ({length})
                                        {column.showCurrentMonthPayment && <div className="payment-amount-header"> {this.state.paymentsInCurrentMonth.toLocaleString().replace(/,/g, ' ')}</div>}
                                        {column.showNextMonthPayment && <div className="payment-amount-header"> {this.state.paymentsInNextMonth.toLocaleString().replace(/,/g, ' ')}</div>}
                                        {column.isInvoice && <div className="invoice-amount">+{sum.toLocaleString().replace(/,/g, ' ')}</div>}
                                        {!column.isInvoice && <div>{sum.toLocaleString().replace(/,/g, ' ')}</div>}
                                        
                                    </div>
                                );
                            })}
                        </div>
                        <div className="sale-column-table">
				        {this.columns.map((column) => {
                            return (
                                
						        <SaleBoardColumn
                                    name={column.name}
                                    id={column.id}
                                    onTimeChange={this.onTimeChange}
                                    sales={this.state.sales.filter((w) => { return w.statusId === column.id; }).sort((a, b) => b.position - a.position)}
                                    invoices={this.state.invoices.filter((w) => { return w.statusId === column.id; }).sort((a, b) => new Date(a.date) - new Date(b.date))}
                                    onDragEnter={this.handleOnDragEnter}
                                    onDragEnd={this.handleOnDragEnd}
                                    onSaleUpdate={this.handleSaleFlagUpdate}
                                    key={column.id}
                                    onDragPositionChange={this.handleDragSrcPositionChange}
                                    onCardOpen={this.handleCardOpen}
                                    onCtrlCardClick={this.handleCtrlCardClick}
						        />
					        );
                            })}
                        </div>
                    </DragDropContext>
                    </div>

                <SaleDialog onSaleUpdate={this.handleSaleUpdate} />
                <InvoiceDialog onInvoiceUpdate={this.handleInvoiceUpdate} />
            </div>
        );
	}
}

/*
 * The SaleBoard Board Column React component
 */
class SaleBoardColumn extends React.Component {
	constructor(props) {
		super(props);
		this.state = ({ mouseIsHovering: false });
	}

	componentWillReceiveProps(nextProps) {
        this.setState({ mouseIsHovering: false });
	}

    generateSaleBoardCards(provided, snapshot) {
        return this.props.sales.slice(0).map((sale, index) => {
            return (
                <Draggable draggableId={sale.id} index={index} key={sale.id}>
                    {(provided, snapshot) => (
                        <SaleBoardCard
                            sale={sale}
                            key={sale.id}
                            innerRef={provided.innerRef}
                            provided={provided}
                            isDragging={snapshot.isDragging}
                            snapshot={snapshot}
                            onTimeChange={this.props.onTimeChange}
                            onSaleUpdate={this.props.onSaleUpdate}
                            onCardOpen={this.props.onCardOpen}
                            onCtrlCardClick={this.props.onCtrlCardClick}
                        />)
                    }
                </Draggable>
			);
		});
    }

    generateInvoiceBoardCards(provided, snapshot) {
        return this.props.invoices.slice(0).map((sale, index) => {
            return (
                <Draggable draggableId={sale.id} index={index} key={sale.id}>
                    {(provided, snapshot) => (
                        <InvoiceBoardCard
                            sale={sale}
                            key={sale.id}
                            innerRef={provided.innerRef}
                            provided={provided}
                            isDragging={snapshot.isDragging}
                            snapshot={snapshot}
                            onTimeChange={this.props.onTimeChange}
                            onSaleUpdate={this.props.onSaleUpdate}
                            onCardOpen={this.props.onCardOpen}
                            onCtrlCardClick={this.props.onCtrlCardClick}
                        />)
                    }
                </Draggable>
            );
        });
    }

	render() {
        return (
            <Droppable droppableId={this.props.id} type="TASK">
                {(provided, snapshot) => <div
                    className="droppable-column"
                    ref={provided.innerRef}
                    {...provided.droppableProps}

                >
                    <div>                        
                        <div className="SaleBoard-column">                            
                            {this.generateSaleBoardCards(provided, snapshot)}
                            {this.generateInvoiceBoardCards(provided, snapshot)}
                        </div>
                        {provided.placeholder}
                    </div>
                </div>}
            </Droppable>
    );
}
}